<template>
    <div class="main-entrance">
        <div class="body">
            <div
                @click="jumpTo('cq-index')"
                class="body-circle body-circle-tLeft"
            >
                <img
                    src="@/assets/images/main-circle-1.png"
                    class="body-circle-img"
                />
                <span>农村产权交易大数据</span>
            </div>
            <div
                @click="jumpTo('ns-index')"
                class="body-circle body-circle-tRight"
            >
                <img
                    src="@/assets/images/main-circle-2.png"
                    class="body-circle-img"
                />
                <span>丰城市农事服务大数据平台</span>
            </div>
            <div class="body-ball body-ball-middle">
                <img src="@/assets/images/main-group.png" />
                <img src="@/assets/images/main-ball.png" />
                <span>丰城市农事社会化服务大数据</span>
                <img src="@/assets/images/main-ball-bg.png" />
            </div>
            <div
                @click="jumpTo('develop')"
                class="body-circle body-circle-bLeft"
            >
                <img
                    src="@/assets/images/main-circle-3.png"
                    class="body-circle-img"
                />
                <span>农资农机交易</span>
            </div>
            <div
                @click="jumpTo('develop')"
                class="body-circle body-circle-bRight"
            >
                <img
                    src="@/assets/images/main-circle-4.png"
                    class="body-circle-img"
                />
                <span>农事增值服务</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        jumpTo(name) {
            if (name !== 'develop') {
                this.$router.push({
                    name,
                    query: {
                        id: this.$route.query.id || '1565',
                        mode: true,
                        tag: 'fc-screen'
                    }
                })
            } else {
                return this.$message({
                    message: '正在开发中，敬请期待！',
                    type: 'warning'
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@keyframes opacity {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes clockwise_rotation {
    0% {
        transform: rotate(0);
    }
    50% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes anticlockwise_rotation {
    0% {
        transform: rotate(360deg);
    }
    50% {
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(0);
    }
}
.main-entrance {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('../../assets/images/bg.jpg');
    background-color: #04090f; // for ie10
    margin: 0;
    overflow: hidden;
    .body {
        height: calc(100% - 15px);
        margin: 14px 20px 45px 20px;
        padding: 38px 10px 10px 10px;
        position: relative;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url('../../assets/images/main-bg.png');
        display: flex;
        justify-content: center;
        align-items: center;
        &-circle {
            width: 370px;
            height: 370px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            cursor: pointer;
            &-bLeft,
            &-bRight {
                width: 330px;
                height: 330px;
            }
            &-tLeft {
                top: 120px;
                left: 70px;
            }
            &-tRight {
                top: 120px;
                right: 70px;
                > span {
                    width: 200px !important;
                }
            }
            &-bLeft {
                bottom: 70px;
                left: 130px;
            }
            &-bRight {
                bottom: 70px;
                right: 130px;
            }
            > img {
                width: 100%;
                height: 100%;
                position: absolute;
                animation: clockwise_rotation 20s linear infinite;
            }
            > span {
                font-size: 26px;
                color: #fff;
                position: relative;
                display: inline-block;
                width: 180px;
                line-height: 32px;
                text-align: center;
                letter-spacing: 2px;
                -webkit-text-stroke: 5px rgba(39, 195, 254, 0.2);
            }
        }
        &-ball {
            &-middle {
                width: 840px;
                height: 840px;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column;
                > img {
                    width: 842px;
                    height: 837px;
                    position: absolute;
                    animation: clockwise_rotation 100s linear infinite;
                    &:first-child {
                        animation: opacity 4s ease-out infinite alternate;
                    }
                    &:last-child {
                        width: 460px;
                        height: 460px;
                        animation: none;
                    }
                }
                > span {
                    font-size: 34px;
                    color: #fff;
                    position: absolute;
                    display: inline-block;
                    width: 260px;
                    line-height: 40px;
                    text-align: center;
                    letter-spacing: 2px;
                    -webkit-text-stroke: 5px rgba(39, 195, 254, 0.2);
                }
                &::before {
                    content: '';
                    width: 510px;
                    height: 510px;
                    position: absolute;
                    top: calc(50% - 255px);
                    left: calc(50% - 255px);
                    z-index: 1;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-image: url('../../assets/images/main-ball-orange-line.png');
                    animation: clockwise_rotation 10s linear infinite;
                }
                &::after {
                    content: '';
                    width: 570px;
                    height: 570px;
                    position: absolute;
                    top: calc(50% - 290px);
                    left: calc(50% - 290px);
                    z-index: 1;
                    position: absolute;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    background-image: url('../../assets/images/main-ball-blue-line.png');
                    animation: anticlockwise_rotation 10s linear infinite;
                }
            }
        }
    }
}
</style>
